<template>
    <div id="item-container">
        <b-row>
            <b-col>
                <MdTitle
                    v-bind:Text="
                        this.editMode
                            ? $t('programSetup.EditProgram')
                            : $t('programSetup.AddProgram')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12" lg="12">
                <div class="accordion" role="tablist">
                    <b-card no-body class="noteSearchPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button
                                block
                                class="collapseBTN text-truncate"
                                v-on:click="toggleAccordion1"
                            >
                                <b-icon icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                                {{ $t('Shared.General') }}
                            </b-button>
                        </b-card-header>
                        <b-collapse
                            id="program-accordion-1"
                            visible
                            accordion="ClinicalNotes"
                            role="tabpanel"
                            v-show="ShowFilter && !ShowTherapiesP && !ShowOccurrence"
                            v-on:click="ShowFilter = true"
                        >
                            <b-card-body class="p-1">
                                <b-card-text class="notesPanelsChartReview cutescroll">
                                    <b-row>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('Shared.Code')"
                                                v-bind:Name="'Code'"
                                                v-bind:TypeProp="'text'"
                                                v-bind:MaxLengthProp="6"
                                                v-model="editableItem.code"
                                                v-bind:Id="'input_code'"
                                                :isReadOnly="isReadOnly || editMode"
                                                :isRequired="true"
                                                :isValid="isCodeValid"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('Shared.Name')"
                                                v-bind:Name="'name'"
                                                v-bind:TypeProp="'text'"
                                                v-bind:MaxLengthProp="50"
                                                v-model="editableItem.name"
                                                v-bind:Id="'input_code'"
                                                :isReadOnly="isReadOnly"
                                                :isRequired="true"
                                                :isValid="isNameValid"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('Shared.Description')"
                                                v-bind:TypeProp="'text'"
                                                v-bind:Name="'description'"
                                                v-model="editableItem.description"
                                                v-bind:Id="'input_description'"
                                            >
                                            </MdEdit>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('programSetup.DefaultCondCode')"
                                                v-bind:TypeProp="'text'"
                                                v-bind:Name="'default-cond-code'"
                                                v-model="editableItem.conditionCode"
                                                v-bind:Id="'input_description'"
                                                :MaxLengthProp="2"
                                            >
                                            </MdEdit>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12" v-if="canUpdateScheduler">
                                            <MdSelect
                                                v-bind:Label="$tc('Shared.AppointmentType')"
                                                v-bind:Options="AppointmentTypesOptions"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Model="appointmentTypes"
                                                v-bind:Multiple="true"
                                                :Input="changeDropDownAppointmentType"
                                            />
                                        </b-col>
                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('programSetup.CanBpDrive')"
                                                v-bind:Name="'checkbox-canbpdrive'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="editableItem.canbypassdrivercheck"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('Shared.Inpatient')"
                                                v-bind:Name="'isInpatient'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="editableItem.isInPatient"
                                            />
                                        </b-col>
                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('programSetup.FallowCk')"
                                                v-bind:Name="'checkbox-fallowck'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="editableItem.followScheduler"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>

                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('programSetup.AllowIP')"
                                                v-bind:Name="'checkbox-allowip'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="editableItem.allowInternalPrescriptions"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>

                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('programSetup.OverwriteProgram')"
                                                v-bind:Name="'checkbox-Overwrite-Program'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="overwriteProgram"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="openNotesPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block v-on:click="toggleAccordion2" class="collapseBTN">
                                <b-icon icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                                {{ $t('programSetup.TherapiesInP') }}
                            </b-button>
                        </b-card-header>
                        <b-collapse
                            id="program-accordion-2"
                            accordion="ClinicalNotes"
                            role="tabpanel"
                            v-show="ShowTherapiesP && !ShowFilter && !ShowOccurrence"
                            v-on:click="ShowTherapiesP = true"
                            :class="{ show: ShowTherapiesP }"
                            ref="a2"
                        >
                            <b-card-body class="p-1">
                                <b-card-text>
                                    <div class="w-100">
                                        <b-row>
                                            <b-col class="col-sm-12 col-md-3">
                                                <MdButton
                                                    v-bind:Label="$t('Shared.Add')"
                                                    v-bind:ClassProp="
                                                        this.isReadOnly
                                                            ? 'btn btn-primary my-3 btn-block'
                                                            : 'btn btn-primary my-3 btn-block btn-login'
                                                    "
                                                    v-bind:IconClass="'ti-plus pr-1'"
                                                    v-bind:isReadOnly="this.isReadOnly"
                                                    v-on:click="addTest"
                                                >
                                                </MdButton>
                                            </b-col>
                                            <b-col class="col-sm-12 col-md-9 mb-4">
                                                <div
                                                    class="textlabel"
                                                    :data-label="this.$t('Shared.SearchElements')"
                                                >
                                                    <div class="input-group" dir="ltr">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            :dir="dirInput"
                                                            v-model="searchTest"
                                                            @keyup.enter="findTests"
                                                        />
                                                        <div class="input-group-append">
                                                            <MdButton
                                                                v-bind:Name="'btnsearchinput'"
                                                                v-bind:VariantProp="
                                                                    'btn btn-sm search-attached'
                                                                "
                                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                                v-on:click="findTests"
                                                            >
                                                            </MdButton>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col>
                                                <MdTablePaginationClient
                                                    v-bind:fields="fields"
                                                    v-bind:items="filteredTherapies"
                                                    v-bind:totalRows="totalRows"
                                                    v-bind:isReadOnly="isReadOnly"
                                                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                                                    v-bind:currentPage="currentPage"
                                                    v-bind:perPage="perPage"
                                                    v-bind:pageOptions="pageOptions"
                                                    :onRowSelected="onRowSelected"
                                                    :onFiltered="onFiltered"
                                                    :pageChanged="pageChanged"
                                                    :perPageFunction="PerPageFunction"
                                                    :deleteIconEvent="removeTherapy"
                                                    v-bind:VisibleDeleteIcon="true"
                                                    :RowClick="RowClick"
                                                    :ShowDetails="true"
                                                    :customActionButtons="customActionButtons"
                                                >
                                                    <template #row-details="{ row }">
                                                        <div class="card mb-3 w-100">
                                                            <therapy-details
                                                                v-model="row.data.items"
                                                                :remove="removeTherapyProgram"
                                                                :removeDetail="
                                                                    removeTherapyProgramDetail
                                                                "
                                                                :editDetail="editTherapyScheduler"
                                                            ></therapy-details>
                                                        </div>
                                                    </template>
                                                </MdTablePaginationClient>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="openNotesPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block v-on:click="toggleAccordion3" class="collapseBTN">
                                <b-icon icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                                {{ $tc('Admission.Occurrence', 2) }}
                            </b-button>
                        </b-card-header>
                        <b-collapse
                            id="program-accordion-3"
                            accordion="ClinicalNotes"
                            role="tabpanel"
                            v-show="ShowOccurrence && !ShowTherapiesP && !ShowFilter"
                            v-on:click="ShowOccurrence = true"
                            :class="{ show: ShowOccurrence }"
                            ref="a3"
                        >
                            <b-card-body class="p-1">
                                <b-card-text>
                                    <program-occurrence
                                        v-model="editableItem.occurrences"
                                        :isReadOnly="isReadOnly"
                                    ></program-occurrence>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')"
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly="this.isReadOnly"
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>

        <ModalTableMultiSelectServer
            v-bind:Resource="resourceParameter"
            v-bind:TypeOption="refCode"
            @getCodeConditionOK="onCodeConditionAdd($event)"
            @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="lookupFields"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('Shared.Therapies')"
            v-bind:ModalId="modalId"
            v-bind:ReturnAll="true"
        ></ModalTableMultiSelectServer>

        <therapy-scheduler-modal
            :visible.sync="therapySchedulerVisible"
            @ok="saveTherapyScheduler"
            v-model="editableTherapy"
            :program="editableProgram.name"
            :therapists="TherapistList"
            :locations="roomList"
        >
        </therapy-scheduler-modal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import Utils from '@/common/utils.js';
import GlobalService from '@/services/global.service';
import AppointmentTypes from '@/services/appointmenttypes.service';
import ProgramService from '@/services/programs.services';
import TherapyService from '@/services/therapy.service';
import RoomsService from '@/services/rooms.service';
import moment from 'moment';
import TherapyDetails from './therapyDetails';
import TherapySchedulerModal from './therapySchedulerModal.vue';
import ProgramOccurrence from './programOccurrence.vue';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('programSetupListing.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    mixins: [ShowMessage, DBFunctions],
    components: { TherapyDetails, TherapySchedulerModal, ProgramOccurrence },
    props: {
        editMode: Boolean
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.editMode,
                favButtonAtion: false
            },

            isReadOnly: false,
            isEditable: true,
            editableItem: {
                code: '',
                name: '',
                description: '',
                apptType: '',
                therapies: [],
                occurrences: [],
                followScheduler: false,
                canbypassdrivercheck: this.$store.state.providerCanBypassDriverCheck,
                isInPatient:
                    this.$store.state.getProviderType &&
                    (this.$store.state.getProviderType.toUpperCase() === 'IPF' ||
                        this.$store.state.getProviderType.toUpperCase() === 'IRF'),
                allowInternalPrescriptions: false,
                conditionCode: ''
            },
            dcpt: '',
            dProgram: '',
            fields: [
                {
                    key: 'name',
                    sortable: true,
                    label: this.$t('Shared.Name'),
                    class: 'text-left',
                    thStyle: { width: '65%' }
                },
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.Code'),
                    class: 'text-left',
                    thStyle: { width: '15%' }
                },
                {
                    key: 'cptCode',
                    sortable: true,
                    label: this.$t('DrugInventoryItem.CPTCode'),
                    class: 'text-left',
                    thStyle: { width: '15%' }
                }
            ],
            lookupFields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-left' },
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-left' },
                {
                    key: 'cpt',
                    sortable: true,
                    label: this.$t('DrugInventoryItem.CPTCode'),
                    class: 'text-left'
                }
            ],
            pageOptions: [5, 10, 15],
            perPage: 10,
            currentPage: 1,
            modalId: Utils.generateUUID(),
            resourceParameter: '',
            refCode: 'testOrder',
            searchTest: '',
            search: {
                tests: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            TherapistList: [],
            TherapistVmodel: '',
            fullParam: {
                PageSize: 0,
                PageNumber: 0
            },
            appointmentTypesOptions: [],
            appointmentTypes: null,
            ShowFilter: true,
            ShowTherapiesP: false,
            ShowOccurrence: false,
            ClassAccordion: 'show',
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            therapySchedulerVisible: false,
            editableProgram: { name: '' },
            editableTherapy: {},
            editableItemIndex: -1,
            roomList: [],
            isNameValid: true,
            isCodeValid: true,
            overwriteProgram: true,
            customActionButtons: [
                {
                    id: 'add-therapy',
                    visible: true,
                    icon: 'med-doc-new',
                    handler: this.addTherapyScheduler,
                    tooltip: this.$t('MdNote.AddTherapy')
                }
            ]
        };
    },

    computed: {
        therapiesAPI() {
            return 'therapies?withScheduler=true';
        },

        items() {
            const seen = new Set();
            const therapies = this.editableItem.therapies
                .filter(item => {
                    const key = item.code.toLowerCase();

                    if (seen.has(key)) {
                        return false;
                    }

                    seen.add(key);
                    return true;
                })
                .map(x => ({
                    code: x.code,
                    name: x.name,
                    cptCode: x.cpt,
                    items: this.editableItem.therapies
                        .filter(y => y.coursecode === x.code)
                        .sort((a, b) => {
                            if (a.meetingDay === b.meetingDay) {
                                return moment(a.meetingTime) < moment(b.meetingTime);
                            }

                            return a.meetingDay < b.meetingDay;
                        })
                }));

            return therapies;
        },

        filteredTherapies() {
            const search = (this.search.tests || '').trim().toLowerCase();
            const list = this.items || [];

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.name || '').toLowerCase();
                const code = (item.code || '').toLowerCase();
                const cptCode = (item.cptCode || '').toLowerCase();

                return name.includes(search) || code.includes(search) || cptCode.includes(search);
            });
        },

        totalRows() {
            return this.filteredTherapies.length;
        },

        showMessageIsEmpty() {
            return this.totalRows === 0;
        },

        canUpdateScheduler() {
            return this.$store.state.providerCanUpdateScheduler;
        }
    },

    methods: {
        goBack() {
            this.$router.push({ name: 'ProgramListing' });
        },

        SaveOrEdit() {
            if (!this.isReadOnly) {
                elemSaveBtn.setAttribute('disabled', '');
                if (this.validate_required()) {
                    if (this.editMode) {
                        this.update();
                    } else {
                        this.save();
                    }
                }
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        save() {
            const params = {
                ...this.editableItem,
                overwriteProgram: this.overwriteProgram
            };
            ProgramService.add(params)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            const params = {
                ...this.editableItem,
                overwriteProgram: this.overwriteProgram
            };
            ProgramService.update(this.$route.params.id, params)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            this.isCodeValid = !Utils.isNullOrEmptyString(this.editableItem.code);
            this.isNameValid = !Utils.isNullOrEmptyString(this.editableItem.name);
            return this.isCodeValid && this.isNameValid;
        },

        async getProgramAsync() {
            if (this.editMode) {
                ProgramService.getProgramWithTherapies(this.$route.params.id)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.editableItem = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        onFiltered() {
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            if (this.currentPage > this.totalRows / this.perPage) {
                this.currentPage = 1;
            }
        },

        onRowSelected() {},

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        async onCodeConditionAdd(results) {
            this.$bvModal.hide(this.modalId);
            this.resourceParameter = '';

            if (!Array.isArray(results) || results.length === 0) {
                return;
            }

            let hasNewItems = false;

            for (let index = 0; index < results.length; index++) {
                const result = results[index];

                if (!result || !result.code) {
                    continue;
                }

                try {
                    const code = result.code.trim();
                    const indexOf = this.items.findIndex(test => test.code === code);

                    if (indexOf === -1) {
                        const response = await TherapyService.get(result.code.trim());
                        const therapy = response.data;

                        const data = {
                            code: code,
                            coursecode: code,
                            name: result.name.trim(),
                            cptCode: result.cptcode?.trim(),
                            location: therapy.location,
                            therapistCode: therapy.therapistcode,
                            touched: true
                        };

                        if (response.data.sun === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 1,
                                meetingTime: therapy.monTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.monTimeto
                            });
                            hasNewItems = true;
                        }

                        if (therapy.mon === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 2,
                                meetingTime: therapy.sunTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.sunTimeto
                            });
                            hasNewItems = true;
                        }

                        if (therapy.tue === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 3,
                                meetingTime: therapy.tueTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.tueTimeto
                            });
                            hasNewItems = true;
                        }

                        if (therapy.wed === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 4,
                                meetingTime: therapy.wedTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.wedTimeto
                            });
                            hasNewItems = true;
                        }

                        if (therapy.thu === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 5,
                                meetingTime: therapy.thuTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.thuTimeto
                            });
                            hasNewItems = true;
                        }

                        if (therapy.fri === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 6,
                                meetingTime: therapy.friTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.friTimeto
                            });
                            hasNewItems = true;
                        }

                        if (therapy.sat === 'Y') {
                            this.editableItem.therapies.push({
                                ...data,
                                meetingDay: 7,
                                meetingTime: therapy.satTime ?? '1899-12-30T00:00:00',
                                timeTo: therapy.satTimeto
                            });
                            hasNewItems = true;
                        }
                    }
                } catch (error) {
                    this.showResponseErrorMessage(error);
                }
            }

            if (hasNewItems) {
                this.editableItem.therapies.sort((a, b) => {
                    const x = a.name.toLowerCase();
                    const y = b.name.toLowerCase();
                    return x < y ? -1 : x > y ? 1 : 0;
                });

                this.pendingChanges = true;
                this.checkUserAction();
            }
        },

        onCodeConditionCancel() {
            this.resourceParameter = '';
        },

        addTest() {
            this.resourceParameter = '/' + this.therapiesAPI;
            this.modelFilter = {
                code: 1,
                description: this.$t('programSetupListing.Title'),
                resource: this.therapiesAPI
            };
            this.$bvModal.show(this.modalId);
        },

        removeTherapy(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('programSetupListing.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        let deleted = false;
                        let indexOf = this.editableItem.therapies.findIndex(
                            test => test.code === row.code
                        );

                        while (indexOf !== -1) {
                            this.editableItem.therapies.splice(indexOf, 1);
                            deleted = true;

                            indexOf = this.editableItem.therapies.findIndex(
                                test => test.code === row.code
                            );
                        }

                        if (deleted) {
                            this.pendingChanges = true;
                            this.checkUserAction();
                        }
                    }
                });
        },

        RowClick() {},

        findTests() {
            this.search.tests = this.searchTest;
            this.currentPage = 1;
        },

        async getEmployees() {
            await GlobalService.getEmployeeActive()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.TherapistList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getAppointmentTypes() {
            if (this.canUpdateScheduler) {
                await AppointmentTypes.getAll()
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.appointmentTypesOptions = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        async getRooms() {
            await RoomsService.getAllRooms()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.roomList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        changeDropDownAppointmentType(value) {
            this.editableItem.apptType = value ? value.code : null;
        },

        toggleAccordion1() {
            this.ShowFilter = !this.ShowFilter;
            this.ShowTherapiesP = false;
            this.ShowOccurrence = false;
        },

        toggleAccordion2() {
            this.ShowFilter = false;
            this.ShowTherapiesP = !this.ShowTherapiesP;
            this.ShowOccurrence = false;
        },

        toggleAccordion3() {
            this.ShowFilter = false;
            this.ShowTherapiesP = false;
            this.ShowOccurrence = !this.ShowOccurrence;
        },

        removeTherapyProgram(row, day) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('programSetupListing.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        let changed = false;
                        const forDeleted = row.filter(x => x.meetingDay === day);
                        forDeleted.forEach(element => {
                            const indexOf = this.editableItem.therapies.indexOf(element);

                            if (indexOf !== -1) {
                                this.editableItem.therapies.splice(indexOf, 1);
                                changed = true;
                            }
                        });

                        if (changed) {
                            this.pendingChanges = true;
                            this.checkUserAction();
                        }
                    }
                });
        },

        removeTherapyProgramDetail(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('programSetupListing.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        const indexOf = this.editableItem.therapies.indexOf(row);

                        if (indexOf !== -1) {
                            this.editableItem.therapies.splice(indexOf, 1);
                            this.pendingChanges = true;
                            this.checkUserAction();
                        }
                    }
                });
        },

        addTherapyScheduler(item) {
            this.editableProgram = item;
            this.editableTherapy = null;
            this.editableItemIndex = -1;
            this.therapySchedulerVisible = true;
        },

        editTherapyScheduler(item) {
            this.editableItemIndex = this.editableItem.therapies.indexOf(item);
            this.editableTherapy = item;
            this.editableProgram = this.filteredTherapies.find(x => x.code === item.code);
            this.therapySchedulerVisible = true;
        },

        saveTherapyScheduler(item) {
            if (this.editableItemIndex === -1) {
                this.editableItem.therapies.push({
                    ...item,
                    code: this.editableProgram.code,
                    coursecode: this.editableProgram.code,
                    name: this.editableProgram.name,
                    cptCode: this.editableProgram.cptCode,
                    progcode: this.editableItem.code
                });
            } else {
                this.$set(this.editableItem.therapies, this.editableItemIndex, item);
            }

            this.pendingChanges = true;
            this.checkUserAction();
        }
    },

    async mounted() {
        let promiseToLoad = [
            this.getProgramAsync(),
            this.getEmployees(),
            this.getAppointmentTypes(),
            this.getRooms()
        ];
        await Promise.allSettled(promiseToLoad);
        this.appointmentTypes = this.appointmentTypesOptions.find(
            x => x.code === this.editableItem.apptType
        );

        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_inventory_item');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    created() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );

        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
